import { render, staticRenderFns } from "./LayoutStructure.vue?vue&type=template&id=c2a9e09c&scoped=true"
import script from "./LayoutStructure.vue?vue&type=script&lang=js"
export * from "./LayoutStructure.vue?vue&type=script&lang=js"
import style0 from "./LayoutStructure.vue?vue&type=style&index=0&id=c2a9e09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a9e09c",
  null
  
)

export default component.exports